import * as React from "react"
import { Database, Home, Palette, ShieldCheck, Users } from "lucide-react"
import { MainNav, type NavItemDef } from "@/components/MainNav"

const ADMIN_NAV_ITEMS: NavItemDef[] = [
  {
    href: "/",
    icon: Home,
    label: "App Home",
    match: () => false,
  },
  {
    href: "/admin/users",
    icon: Users,
    label: "Users",
    match: (url) => url.startsWith("/admin/users"),
  },
  {
    href: "/admin/allowed_emails",
    icon: ShieldCheck,
    label: "Access",
    match: (url) => url.startsWith("/admin/allowed_emails"),
  },
  {
    href: "/admin/data_refreshes",
    icon: Database,
    label: "Data Refresh",
    match: (url) => url.startsWith("/admin/data_refreshes"),
  },
  {
    href: "/admin/design-system",
    icon: Palette,
    label: "Design System",
    match: (url) => url.startsWith("/admin/design-system"),
  },
]

export function AdminShell({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex min-h-screen bg-page text-ink-body">
      <MainNav items={ADMIN_NAV_ITEMS} brandHref="/admin/users" />
      <main className="min-w-0 flex-1 px-6 py-8 sm:px-10">
        <div className="mx-auto max-w-4xl">{children}</div>
      </main>
    </div>
  )
}
